<template>
          <!-- Contact Start -->
        <section class="contact-section">
            <div class="container">
                <div class="row">
                    <div class="col-md-4">
                        <div class="contact--info-area">
                            <h3>Get in touch</h3>
                            <p>
                                Looking for help? Fill the form and let us help you for what you need.
                            </p>
                            <!-- <div class="single-info">
                                <h5>Headquaters</h5>
                                <p>
                                    <i class="fal fa-home"></i>
                                    744 New York Ave, Brooklyn, Kings,<br> New York 10224
                                </p>
                            </div> -->
                            <div class="single-info">
                                <h5>Support</h5>
                                <p>
                                    <i class="fal fa-envelope"></i>
                                    Support@TroFii.Net
                                </p>
                            </div>
                            <div class="ab-social">
                                <h5>Follow Us</h5>
                                <a class="fac" target="_blank" href="https://www.facebook.com/trofiiapp/"><i class="fab fa-facebook-f"></i></a>
                                <!-- <a class="twi" href="#"><i class="fab fa-twitter"></i></a> -->
                                <a class="insta" target="_blank" href="https://www.instagram.com/trofiiapp/"><i class="fab fa-instagram"></i></a>
                                <!-- <a class="lin" target="_blank" href="#"><i class="fab fa-linkedin-in"></i></a> -->
                            </div>
                        </div>
                    </div>
                    <div class="col-md-8">
                        <div class="contact-form">
                            <h4>Let’s Connect</h4>
                            <p>Let us know your comments and your opinion about TroFii.</p>
                            <form action="mailto:Support@TroFii.Net" method="post" class="row">
                                <div class="col-md-6">
                                    <input type="text" name="f-name" placeholder="First Name">
                                </div>
                                <div class="col-md-6">
                                    <input type="text" name="l-name" placeholder="Last Name">
                                </div>
                                <div class="col-md-6">
                                    <input type="email" name="email" placeholder="Email Address">
                                </div>
                                <div class="col-md-6">
                                    <input type="number" name="phone" placeholder="Phone Number">
                                </div>
                                <div class="col-md-12">
                                    <input type="text" name="suject" placeholder="Subject">
                                </div>
                                <div class="col-md-12">
                                    <textarea name="message" placeholder="How can we help?"></textarea>
                                </div>
                                <div class="col-md-6">
                                    <div class="condition-check">
                                        <input id="terms-conditions" type="checkbox">
                                        <label for="terms-conditions">
                                            I agree to the <a target="_blank" href="https://firebasestorage.googleapis.com/v0/b/worests.appspot.com/o/assets%2FTerms%20%26%20Conditions%20for%20TroFii.html?alt=media&token=3366965f-9b0b-47e5-b58a-a7d940fa29c5">Terms & Conditions</a>      
                                        </label>
                                    </div>
                                </div>
                                <div class="col-md-6 text-right">
                                    <input type="submit" name="submit" value="Send Message">
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- Contact End -->
</template>

<script>
export default {

}
</script>

<style>

</style>